/**
 * The turn the onboarding chat sends for the founder when a deck or site
 * parse lands, so Lev delivers its read. Sent verbatim on every path (the
 * model and the session history key on it); only its rendering changes.
 */
export const MATERIALS_NUDGE_MESSAGE = "My materials should be ready now - what's your read?";

/**
 * How a program founder's chats show that turn (the lander, and the canvas
 * chat that carries the onboarding history): the founder never typed it, so
 * it reads as a status line, not as their words.
 */
export const MATERIALS_NUDGE_STATUS_LINE = "Lev finished reading your materials.";
